import { createModel } from '@rematch/core';
import reducers from './reducers';
import state from './state';
import { type RootModel } from './..';

const ui = createModel<RootModel>()({
  name: 'ui',
  state,
  reducers,
});

export default ui;
